import React from 'react'

export default function Enquiries(props) {
    

    return (
        <>
            
        </>
    )
}
